import { Email } from '../primitives';

export function cleanEmail(email: string) {
  const parsedEmail = Email.parse(email);
  return parsedEmail
    .trim()
    .toLowerCase()
    .replaceAll(/\+.*@|@/g, '@');
}
